document.querySelectorAll('[data-map]').forEach(link => {
	link.addEventListener('click', (e) => {
		e.preventDefault();
		const targetId = link.getAttribute('data-map');
		const overlay = document.getElementById(targetId);
		if (overlay) {
			overlay.classList.toggle('active');
		}
	});
});

document.querySelectorAll('.parking-close').forEach(btn => {
	btn.addEventListener('click', () => {
		btn.closest('.parking-overlay').classList.remove('active');
	});
});
